import { useEffect } from 'react';
import { scheduleCopilotLayoutResize } from '../utils/scheduleCopilotLayoutResize';

/** home LeftMenu width transition 时长（index.scss: 0.3s），内嵌 Copilot 收起菜单时需等待 */
const DOCKED_MENU_TRANSITION_MS = 300;

/**
 * Copilot 主会话窗开关时通知页面图表自适应。
 * 封装在 Copilot 侧，不侵入 home / LeftMenu 底层实现。
 */
export function useCopilotChartResizeOnToggle(
  isShowCopilot: boolean,
  isDocked: boolean,
): void {
  useEffect(() => {
    if (!isShowCopilot) return;

    let dockedTimer: number | null = null;

    const notifyChartResize = (): void => {
      if (dockedTimer) {
        window.clearTimeout(dockedTimer);
        dockedTimer = null;
      }
      if (isDocked) {
        dockedTimer = window.setTimeout(() => {
          scheduleCopilotLayoutResize();
          dockedTimer = null;
        }, DOCKED_MENU_TRANSITION_MS);
        return;
      }
      scheduleCopilotLayoutResize();
    };

    notifyChartResize();

    return () => {
      if (dockedTimer) {
        window.clearTimeout(dockedTimer);
      }
      notifyChartResize();
    };
  }, [isShowCopilot, isDocked]);
}
